import PropTypes from 'prop-types';
import moment from 'moment';

export default {
	toAccount: PropTypes.string.isRequired,
	fromAccount: PropTypes.string.isRequired,
	date: PropTypes.object,
	reference: PropTypes.string,
	type: PropTypes.string,
};

export const paymentPropTypes = {
	standing_order_uuid: PropTypes.string,
	reference: PropTypes.string,
	amount: PropTypes.string,
	date: PropTypes.instanceOf(moment),
	fromAccount: PropTypes.string,
	toAccountDetails: PropTypes.shape({
		displayName: PropTypes.string.isRequired,
		sortCode: PropTypes.string.isRequired,
		accountNumber: PropTypes.string.isRequired,
	}),
	type: PropTypes.string,
	frequency: PropTypes.string,
	stopPaymentOption: PropTypes.string,
	stopPaymentOnNumber: PropTypes.number,
};

export const paymentsAPIRequestPropType = PropTypes.shape({
	batch_list: PropTypes.arrayOf(
		PropTypes.shape({
			body: PropTypes.shape({
				account_id: PropTypes.string,
				amount: PropTypes.shape({
					currency: PropTypes.string,
					value: PropTypes.number,
				}),
				beneficiary_id: PropTypes.string,
				payment_date: PropTypes.string,
				source_id: PropTypes.string,
				reference: PropTypes.string,
				approver_id: PropTypes.string,
				batch_id: PropTypes.string,
			}),
			id: PropTypes.string,
			method: PropTypes.string,
			uri: PropTypes.string,
			x_bpi_version: PropTypes.string,
		})
	),
});
